export default "__VITE_ASSET__DbMypQ96__"